<template>
  <component
    :is="tag"
    v-html="html"
  ></component>
</template>

<script>
const ALLOWED_TAGS = [
  'p','div','span','h1','h2','h3','h4','h5','h6'
];

export default {
  name: 'HtmlText',

  props: {
    text: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'p',
      validator: (t) => ALLOWED_TAGS.includes(t) || /^[a-z][a-z0-9-]*$/.test(t),
    },
  },

  computed: {
    html() {
      // 0) HTML escapen
      let s = this.escapeHtml(this.text || '');

      // 1) Links: [label](url) → veilig maken of label laten staan
      s = s.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, label, url) => {
        const safe = this.sanitizeUrl(url);
        return safe
          ? `<a href="${safe}" target="_blank" rel="noopener noreferrer">${label}</a>`
          : label;
      });

      // 2) Bold: **...**
      s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

      // 3) Italic: *...* (na bold zodat ** niet geraakt wordt)
      s = s.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1<em>$2</em>');

      // 4) Linebreaks → <br>
      s = s.replace(/\r\n|\r|\n/g, '<br>');

      return s;
    },
  },

  methods: {
    // ————— Utils —————
    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    sanitizeUrl(raw) {
      const url = (raw || '').trim();
      if (!url) return '';
      if (url.startsWith('/') || url.startsWith('#')) return url;
      if (/^mailto:[^\s]+$/i.test(url)) return url;
      try {
        const u = new URL(url);
        if (u.protocol === 'http:' || u.protocol === 'https:') return u.href;
      } catch (e) {
        // stil houden of loggen in dev
        if (process && process.env && process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      }
      return ''; // ongeldig/gevaarlijk → geen link maken
    }
  },
};
</script>
